import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { AppConfig } from 'src/assets/config/config/app-config';

@Injectable({ providedIn: 'root' })
export class RulesService {
    apiUrl: string

    constructor(private http: HttpClient,
        private config: AppConfig) {
        this.apiUrl = this.config.getConfig("apiUrl")
    }

    getAllRules() {
        return this.http.get(this.apiUrl + `/workflow/get`).pipe();
    }

    createUpdateRule(payload, rule_id) {
        if (!rule_id) {
            return this.http.post(this.apiUrl + `/workflow/create`, payload).pipe(catchError(this.errorHandler));
        } else {
            payload.ruleId = rule_id
            return this.http.post(this.apiUrl + `/workflow/create`, payload).pipe(catchError(this.errorHandler));
        }
    }

    errorHandler(error: HttpErrorResponse) {
        return throwError(error);
    }

    deleteRule(rule_id) {
        var payload = {
            rule_id: rule_id
        }
        return this.http.put(this.apiUrl + `/workflow/delete/rule`, payload).pipe();
    }
}